// alarms_menu


import React, { useState, useEffect } from "react";
import { MdCheckCircle, MdHighlightOff } from "react-icons/md";
import { motion, AnimatePresence } from "framer-motion";
import "./alarms.css";
import { MdClose } from "react-icons/md";
import "./alarm_notification.css";

const API_URL = process.env.REACT_APP_API_DJANGO_URL;

const AlarmsPage = () => {
  const [sites, setSites] = useState([]);
  const [selectedSite, setSelectedSite] = useState("");
  const [alarms, setAlarms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [timeRange, setTimeRange] = useState("24h");

  // Pagination States
  const [page, setPage] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState("");

  const [ackAlarm, setAckAlarm] = useState(null);   // alarm waiting for remark
const [remark, setRemark] = useState("");
const [ackLoading, setAckLoading] = useState(false);

  const token = localStorage.getItem("accessToken");
  const customerId = localStorage.getItem("customer_id");
  const role = localStorage.getItem("role");
  const userId = localStorage.getItem("userId");

  

  const openAckPopup = (alarm) => {
  setAckAlarm(alarm);
  setRemark("");
};

const closeAckPopup = () => {
  if (ackLoading) return;
  setAckAlarm(null);
  setRemark("");
};



  // Helper to get Status Badge styling and text
  const getStatusLabel = (status) => {
    const labels = {
      ACTIVE_UNACK: { text: "Active / Unack", class: "status-active-unack" },
      ACTIVE_ACK: { text: "Active / Ack", class: "status-active-ack" },
      CLEARED_UNACK: { text: "Cleared / Unack", class: "status-cleared-unack" },
      CLEARED_ACK: { text: "Resolved", class: "status-resolved" },
    };
    return labels[status] || { text: status.replace("_", " "), class: "" };
  };

  useEffect(() => {
    const fetchCustomers = async () => {


      if (role === "CA"|| role === "DC") {
        const customerId = localStorage.getItem("customer_id");
        if (customerId) {
          setSelectedCustomer(customerId);
        }
        return;
      }
      if (role !== "SA") return;

      try {
        const res = await fetch(`${API_URL}/api/get_customers/`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });

        const data = await res.json();

        const customerList = (Array.isArray(data) ? data : []).map((c) => ({
          id: c.id,
          tb_customer_id: c.tb_customer_id,
          name: c.customer_name,
        }));

        setCustomers(customerList);

        if (customerList.length > 0) {
          const firstCustomer = customerList[0].tb_customer_id;
          setSelectedCustomer(firstCustomer);
        }
      } catch (err) {
        console.error("Customer fetch error:", err);
      }
    };

    fetchCustomers();
  }, [role]);

  useEffect(() => {
    const fetchSites = async () => {

      try {
        const token = localStorage.getItem("accessToken");
        // const customerId = localStorage.getItem("customer_id");
        // const customerId =
        //   role === "SA"
        //     ? selectedCustomer
        //     : localStorage.getItem("customer_id");
        // const role = localStorage.getItem("role");
        const userId = localStorage.getItem("userId");

        let siteItems = [];

        // ✅ COMMON HEADERS
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        };

        // ✅ 1. SUPERVISOR
        if (role === "S") {
          const res = await fetch(
            `${API_URL}/api/supervisor_sites/${userId}/`,
            config
          );
          const data = await res.json();

          siteItems = (data.sites || []).map((s) => ({
            id: s.asset_id,
            name: s.name,
          }));
        }

        // ✅ 2. SITE ENGINEER
        else if (role === "SE") {
          const res = await fetch(
            `${API_URL}/api/engineer_sites/${userId}/`,
            config
          );
          const data = await res.json();

          siteItems = (data.sites || []).map((s) => ({
            id: s.asset_id,
            name: s.site_name, // ⚠️ IMPORTANT
          }));
        }

        // ✅ 3. CUSTOMER
        else if (role === "SA" || role === "CA" || role === "DC") {
          if (!selectedCustomer) return; // IMPORTANT FIX

          const res = await fetch(
            `${API_URL}/api/get_customer_sites/${selectedCustomer}/`,
            config
          );
          const data = await res.json();

          siteItems = (data.data || []).map((s) => ({
            id: s.asset_id,
            name: s.name,
          }));
        }


        setSites(siteItems);

        // ✅ Auto select first site
        if (siteItems.length > 0) {
          setSelectedSite(siteItems[0].id);
        }
      } catch (err) {
        console.error("Sites fetch error:", err);
      }
    };

    fetchSites();
  }, [selectedCustomer, role]);

  const fetchAlarms = async (pageNumber = page, size = rowsPerPage) => {
    if (!selectedSite) return;
    setLoading(true);

    const token = localStorage.getItem("accessToken");
    const endTime = Date.now();
    // Use 0 if 'all' is selected, otherwise 24h ago
    const startTime = timeRange === "24h" ? endTime - 86400000 : 0;

    try {
      // 1. Point to your new middle-layer endpoint
      // 2. We pass the 'selectedSite' (asset_id) in the URL path
      const res = await fetch(
        `${API_URL}/api/get_alarms_menu/${selectedSite}/`,
        {
          headers: {
            "Authorization": `Bearer ${token}`,
            "Accept": "application/json",
            "Content-Type": "application/json"
          }
        }
      );

      // Handle Role/Assignment errors (403 Forbidden)
      if (res.status === 403) {
        const errorData = await res.json();
        setAlarms([]);
        setTotalElements(0);
        alert(errorData.error || "Access Denied: You are not assigned to this site.");
        return;
      }

      // Handle Authentication errors (401)
      if (res.status === 401) {
        console.error("Session expired or invalid token");
        // Optional: navigate to login
        return;
      }

      if (!res.ok) throw new Error("Failed to fetch alarms from middle layer");

      const alarmData = await res.json();

      // Since your Django API returns the raw 3TP response on success:
      setAlarms(alarmData.data || []);
      setTotalElements(alarmData.totalElements || 0);
      setPage(pageNumber);

    } catch (err) {
      console.error("Error fetching alarms:", err);
      setAlarms([]);
      setTotalElements(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAlarms(0, rowsPerPage);
  }, [selectedSite, timeRange, rowsPerPage]);



  // Filtered alarms based on selected filter/time/site
  const filteredAlarms = alarms;

  // Frontend pagination
  const paginatedAlarms = filteredAlarms.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const totalFiltered = filteredAlarms.length;

  const startIdx =
    totalFiltered === 0 ? 0 : page * rowsPerPage + 1;

  const endIdx = Math.min(
    page * rowsPerPage + rowsPerPage,
    totalFiltered
  );


  // const handleAcknowledge = async (id) => {
  //   try {
  //     await fetch(`${API_URL}/api/acknowledge_alarm/${id}/`, {
  //       method: "POST",
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //       },
  //     });

  //     fetchAlarms(page, rowsPerPage);
  //   } catch (err) {
  //     console.error("Acknowledge error:", err);
  //   }
  // };


  const handleAcknowledge = async () => {
  if (!ackAlarm) return;

  if (!remark.trim()) {
    alert("Please enter a remark");
    return;
  }

  const authToken = localStorage.getItem("accessToken");
  const username = localStorage.getItem("name");

  try {
    setAckLoading(true);

    // 1) Acknowledge alarm in 3TP
    const ackRes = await fetch(`${API_URL}/api/acknowledge_alarm/${ackAlarm.id.id}/`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${authToken}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });

    if (!ackRes.ok) {
      const err = await ackRes.json();
      console.error("Acknowledge failed", err);
      alert("Failed to acknowledge alarm");
      return;
    }

    // 2) Save acknowledgement info with remark
    try {
      const saveRes = await fetch(`${API_URL}/api/save_alarm_acknowledgement/`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${authToken}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          alarm_id: ackAlarm.id.id,
          alarm_name: ackAlarm.type,
          username: username,
          remark: remark.trim(),
        }),
      });

      if (!saveRes.ok) {
        const err = await saveRes.json();
        console.error("Save acknowledgement failed", err);
      }
    } catch (saveErr) {
      console.error("Save acknowledgement error", saveErr);
    }

    // 3) Close popup and refresh
    setAckAlarm(null);
    setRemark("");
    fetchAlarms(page, rowsPerPage);
  } catch (err) {
    console.error("Acknowledge error:", err);
  } finally {
    setAckLoading(false);
  }
};




  const handleClear = async (id) => {
    try {
      await fetch(`${API_URL}/api/clear_alarm/${id}/`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      fetchAlarms(page, rowsPerPage);
    } catch (err) {
      console.error("Clear error:", err);
    }
  };

  const formatTime = (ts) => (ts ? new Date(ts).toLocaleString() : "---");

  // const startIdx = page * rowsPerPage + 1;
  // const endIdx = Math.min(startIdx + rowsPerPage - 1, totalElements);

  return (
    <div className="alarm-wrapper">
      <div className="alarms-header-main">
        <div className="title-block">
          <div className="header-text-group">
            <h1>Site Alarms</h1>
            <div className="sub-header">
              <div className="status-dot active" style={{ backgroundColor: '#ef4444', boxShadow: '0 0 5px #ef4444' }}></div>
              <span>{timeRange === '24h' ? 'REAL-TIME MODE' : 'HISTORICAL VIEW'}</span>
            </div>
          </div>
        </div>

        <div className="controls-block">
          {localStorage.getItem("role") === "SA" && (
            <div className="site-select-wrapper">
              <select
                value={selectedCustomer}
                onChange={(e) => {
                  setSelectedCustomer(e.target.value);
                  setSites([]);
                  setSelectedSite("");
                }}
              >
                <option value="" disabled>Select Customer</option>

                {customers.map((customer) => (
                  <option
                    key={customer.tb_customer_id}
                    value={customer.tb_customer_id}
                  >
                    {customer.name}
                  </option>
                ))}
              </select>
            </div>
          )}
          <div className="site-select-wrapper">
            <select value={selectedSite} onChange={(e) => setSelectedSite(e.target.value)}>
              {/* <option value="">Select Originator Site</option> */}
              {sites.map(s => <option key={s.id} value={s.id}>
                {s.name}
              </option>)}
            </select>
          </div>

          <div className="time-toggle-pill">
            <button className={timeRange === '24h' ? 'active' : ''} onClick={() => setTimeRange("24h")}>24H</button>
            <button className={timeRange === 'all' ? 'active' : ''} onClick={() => setTimeRange("all")}>ALL</button>
          </div>
        </div>
      </div>

      <div className="alarm-card">
        <div className="table-responsive">
          <table className="alarm-table">
            <thead>
              <tr>
                <th>START TIME</th>
                <th>CLEAR TIME</th>
                <th>ORIGINATOR</th>
                <th>ALARM NAME</th>
                <th>STATUS</th>
                <th>SEVERITY</th>
                {/* <th style={{ textAlign: 'center' }}>ACTIONS</th> */}
                {role !== "SE" && (
                  <th style={{ textAlign: 'center' }}>ACTIONS</th>
                )}
              </tr>
            </thead>
            <tbody>
              <AnimatePresence mode='wait'>
                {paginatedAlarms.map((alarm, idx) => {
                  const statusInfo = getStatusLabel(alarm.status);
                  return (
                    <motion.tr
                      key={alarm.id.id}
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      exit={{ opacity: 0 }}
                      transition={{ delay: idx * 0.02 }}
                    >
                      <td>{formatTime(alarm.startTs)}</td>
                      <td>{alarm.clearTs ? formatTime(alarm.clearTs) : "Active"}</td>
                      <td className="originator-text">{alarm.originatorName}</td>
                      <td className="alarm-name-cell" style={{ fontWeight: 'bold' }}>{alarm.type}</td>
                      <td>
                        <span className={`status-badge ${statusInfo.class}`}>
                          {statusInfo.text}
                        </span>
                      </td>
                      <td>
                        <span className={`sev-badge sev-${alarm.severity.toLowerCase()}`}>
                          {alarm.severity}
                        </span>
                      </td>
                      {/* <td>
                        <div className="action-row-icons" style={{ display: 'flex', gap: '12px', justifyContent: 'center', alignItems: 'center' }}>
                          {(alarm.status.includes("UNACK")) && (
                            <button
                              className="action-icon-btn ack"
                              onClick={() => handleAcknowledge(alarm.id.id)}
                              title="Acknowledge Alarm"
                              style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#10b981', padding: 0, display: 'flex' }}
                            >
                              <MdCheckCircle size={22} />
                            </button>
                          )}
                          {(!alarm.status.includes("CLEARED")) && (
                            <button
                              className="action-icon-btn clr"
                              onClick={() => handleClear(alarm.id.id)}
                              title="Clear Alarm"
                              style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#ef4444', padding: 0, display: 'flex' }}
                            >
                              <MdHighlightOff size={22} />
                            </button>
                          )}
                          {(alarm.status === "CLEARED_ACK") && (
                            <span style={{ fontSize: '11px', color: '#888', fontWeight: '600', letterSpacing: '0.5px' }}>RESOLVED</span>
                          )}
                        </div>
                      </td> */}
                      {role !== "SE" && (
                        <td>
                          <div
                            className="action-row-icons"
                            style={{
                              display: 'flex',
                              gap: '12px',
                              justifyContent: 'center',
                              alignItems: 'center'
                            }}
                          >
                            {(alarm.status.includes("UNACK")) && (
                              <button
                                className="action-icon-btn ack"
                                // onClick={() => handleAcknowledge(alarm.id.id)}
                                // after
                                onClick={() => openAckPopup(alarm)}
                                title="Acknowledge Alarm"
                                style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#10b981', padding: 0, display: 'flex' }}
                              >
                                <MdCheckCircle size={22} />
                              </button>
                            )}

                            {(!alarm.status.includes("CLEARED")) && (
                              <button
                                className="action-icon-btn clr"
                                onClick={() => handleClear(alarm.id.id)}
                                title="Clear Alarm"
                                style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#ef4444', padding: 0, display: 'flex' }}
                              >
                                <MdHighlightOff size={22} />
                              </button>
                            )}

                            {(alarm.status === "CLEARED_ACK") && (
                              <span style={{ fontSize: '11px', color: '#888', fontWeight: '600', letterSpacing: '0.5px' }}>
                                RESOLVED
                              </span>
                            )}
                          </div>
                        </td>
                      )}
                    </motion.tr>
                  );
                })}
              </AnimatePresence>
            </tbody>
          </table>
        </div>

        {!loading && alarms.length === 0 && (
          <div className="empty-notice" style={{ textAlign: 'center', padding: '20px', color: '#888' }}>
            {selectedSite ? "NO SYSTEM ALARMS DETECTED" : "PLEASE SELECT A SITE TO VIEW ALARMS"}
          </div>
        )}

        <div className="pagination-bar">
          <div className="rows-select">
            Rows per page:
            <select
              value={rowsPerPage}
              onChange={(e) => {
                setRowsPerPage(Number(e.target.value));
                setPage(0);
              }}
            >
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={30}>30</option>
            </select>
          </div>
          <div className="page-info">
            {startIdx}-{endIdx} of {totalFiltered}
          </div>
          <div className="page-arrows">
            {/* <button disabled={page === 0} onClick={() => fetchAlarms(page - 1)}>‹</button>
            <button disabled={endIdx >= totalElements} onClick={() => fetchAlarms(page + 1)}>›</button> */}
            <button
              disabled={page === 0}
              onClick={() => setPage(page - 1)}
            >
              ‹
            </button>

            <button
              disabled={endIdx >= totalFiltered}
              onClick={() => setPage(page + 1)}
            >
              ›
            </button>
          </div>
        </div>
      </div>
      {/* Acknowledge Remark Popup */}
{ackAlarm && (
  <div className="ack-popup-overlay" onClick={closeAckPopup}>
    <div className="ack-popup" onClick={(e) => e.stopPropagation()}>
      <div className="ack-popup-header">
        <h3>Acknowledge Alarm</h3>
        <button className="close-icon" onClick={closeAckPopup}>
          <MdClose />
        </button>
      </div>

      <div className="ack-popup-body">
        <p className="ack-popup-alarm">{ackAlarm.type}</p>

        <label htmlFor="ack-remark">Remark</label>
        <textarea
          id="ack-remark"
          rows={4}
          placeholder="Enter remark..."
          value={remark}
          onChange={(e) => setRemark(e.target.value)}
          autoFocus
        />
      </div>

      <div className="ack-popup-footer">
        <button
          className="ack-btn-cancel"
          onClick={closeAckPopup}
          disabled={ackLoading}
        >
          Cancel
        </button>
        <button
          className="ack-btn-save"
          onClick={handleAcknowledge}
          disabled={ackLoading || !remark.trim()}
        >
          {ackLoading ? "Saving..." : "Save"}
        </button>
      </div>
    </div>
  </div>
)}
    </div>
  );
};

export default AlarmsPage;